import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const UserPurchaseOrders = () => {
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPurchaseOrders();
  }, []);

  const fetchPurchaseOrders = async () => {
    try {
      const res = await axios.get('/api/purchase-orders');
      setPurchaseOrders(res.data);
    } catch (error) {
      console.error('Error fetching purchase orders:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statusClass = `badge badge-${status.toLowerCase().replace(' ', '-')}`;
    return <span className={statusClass}>{status}</span>;
  };

  if (loading) {
    return <div className="loading">Loading purchase orders...</div>;
  }

  return (
    <div>
      <h2>Purchase Orders</h2>
      {purchaseOrders.length === 0 ? (
        <div className="card">
          <p>No purchase orders found.</p>
        </div>
      ) : (
        <div>
          {purchaseOrders.map(po => (
            <div key={po._id} className="card">
              <h3>PO Number: {po.poNumber}</h3>
              <p><strong>Status:</strong> {getStatusBadge(po.status)}</p>
              <p><strong>Total Amount:</strong> ${po.totalAmount}</p>
              <p><strong>Routes:</strong> {po.routes.length}</p>
              <p><strong>Issued At:</strong> {new Date(po.issuedAt).toLocaleString()}</p>
              <div style={{ marginTop: '15px' }}>
                <h4>Associated Routes:</h4>
                <ul>
                  {po.routes.map(route => (
                    <li key={route._id}>
                      {route.routeNumber} - {route.startPoint} to {route.endPoint} (${route.price})
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserPurchaseOrders;
